import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Load footer JS after the app has fully rendered
const loadFooterScript = () => {
  const script = document.createElement('script');
  script.src = 'https://cloudcdn.wmca.org.uk/tfwmassets/ds/base/cms/1.0.1/js/footer.min.js';
  script.async = true;
  document.body.appendChild(script);
};

// Use setTimeout to ensure React has fully rendered before loading footer
setTimeout(loadFooterScript, 3000);
